/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserTag } from '../../models/user-tag';

export interface GetProfileViewers$Params {
  id: number;
}

export function getProfileViewers(http: HttpClient, rootUrl: string, params: GetProfileViewers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTag>>> {
  const rb = new RequestBuilder(rootUrl, getProfileViewers.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserTag>>;
    })
  );
}

getProfileViewers.PATH = '/rest/profile/{id}/viewers';
